import * as constants from "./constants";

const initialPermissions = {
  document_control: {
    add_edit: false,
    view: false,
    export: false,
    delete: false,
  },
};

const initialState = {
  allstockManagementRegisters: [],
  fetchingLoading: true,
  fetchDocsLoading: true,
  updateLoading: false,
  totalRecords: 0,
  deleteAttachLoading: false,
  isAddImsDoc: false,
  isUpdateImsDoc: false,
  deletingLoading: false,
  totalAndCompleted: [],
  permissions: initialPermissions,
  currentStockManagementRegister: null,
  newStockManagementRegister: null,
  fetchingStockManagementRegisterById: false,
  stockTakes: {},
  stockTakeErrors: {},
  omniCurrentStock: [],
  // Historical OMNI stock is saved per register, not shared by warehouse.
  omniSnapshotsByRegisterId: {},
  // Prevent duplicate bulk calls when multiple rows expand simultaneously.
  omniSnapshotsPendingByRegisterId: {},
  // Legacy registers have no historical snapshot; this cache is CURRENT stock.
  omniLegacyStockByWarehouse: {},
  omniCurrentStockLoading: false,
  omniCurrentStockError: null,
  currentOmniWarehouseId: null,
  varianceReports: {},
  generatingVarianceReport: false,
  fetchingVarianceReportsLoading: false,
  varianceHistory: {},
  fetchingVarianceHistoryLoading: false,
  syncingLabStock: false,
  syncError: null,
  lastSynced: null,
};

const labsStockManagementReducer = (state = initialState, action) => {
  switch (action.type) {
    case constants.FETCH_ALL_STOCK_MANAGEMENT_REGISTERS:
      return {
        ...state,
        fetchingLoading: true,
        lastFilters: action.data
      };

    case constants.FETCH_ALL_STOCK_MANAGEMENT_REGISTERS_SUCCESS:
      const responseData = action.data;
      const isArray = Array.isArray(responseData);
      const registers = isArray ? responseData : (responseData?.data || []);
      const total = isArray ? responseData.length : (responseData?.meta?.total || responseData?.total || 0);


      return {
        ...state,
        allstockManagementRegisters: Array.isArray(registers) ? registers : [],
        fetchingLoading: false,
        totalRecords: total
      };

    case constants.FETCH_ALL_STOCK_MANAGEMENT_REGISTERS_ERROR:
      return {
        ...state,
        fetchingLoading: false
      };

    case constants.FETCH_STOCK_MANAGEMENT_REGISTER:
      return {
        ...state,
        fetchingStockManagementRegisterById: true
      };

    case constants.FETCH_STOCK_MANAGEMENT_REGISTER_SUCCESS:
      return {
        ...state,
        currentStockManagementRegister: action.data,
        fetchingStockManagementRegisterById: false
      };

    case constants.FETCH_STOCK_MANAGEMENT_REGISTER_ERROR:
      return {
        ...state,
        fetchingStockManagementRegisterById: false
      };

    case constants.CREATE_STOCK_MANAGEMENT_REGISTER:
      return {
        ...state,
        updateLoading: true
      };

    case constants.CREATE_STOCK_MANAGEMENT_REGISTER_SUCCESS:
      return {
        ...state,
        allstockManagementRegisters: [action.data, ...state.allstockManagementRegisters],
        currentStockManagementRegister: action.data,
        newStockManagementRegister: action.data,
        updateLoading: false
      };

    case constants.CREATE_STOCK_MANAGEMENT_REGISTER_ERROR:
      return {
        ...state,
        updateLoading: false
      };

    case constants.UPDATE_STOCK_MANAGEMENT_REGISTER:
      return {
        ...state,
        updateLoading: true
      };

    case constants.UPDATE_STOCK_MANAGEMENT_REGISTER_SUCCESS:
      return {
        ...state,
        allstockManagementRegisters: state.allstockManagementRegisters.map(register =>
          register.id === action.data.id ? action.data : register
        ),
        currentStockManagementRegister: action.data,
        updateLoading: false
      };

    case constants.UPDATE_STOCK_MANAGEMENT_REGISTER_ERROR:
      return {
        ...state,
        updateLoading: false
      };

    case constants.FETCH_ALL_STOCK_TAKES:
      return {
        ...state,
        fetchDocsLoading: true
      };

    case constants.FETCH_ALL_STOCK_TAKES_SUCCESS:
      const { registerId: successRegisterId, data: stockTakesData } = action.data;
      return {
        ...state,
        stockTakes: {
          ...state.stockTakes,
          [successRegisterId]: Array.isArray(stockTakesData) ? stockTakesData : []
        },
        fetchDocsLoading: false
      };

    case constants.FETCH_ALL_STOCK_TAKES_ERROR:
      return {
        ...state,
        fetchDocsLoading: false
      };

    case constants.CREATE_STOCK_TAKE:
      return {
        ...state,
        updateLoading: true
      };

    case constants.CREATE_STOCK_TAKE_SUCCESS:
      const { registerId: successCreateRegisterId, data: stockTakesArray } = action.data;
      return {
        ...state,
        stockTakes: {
          ...state.stockTakes,
          [successCreateRegisterId]: Array.isArray(stockTakesArray) ? stockTakesArray : [stockTakesArray]
        },
        updateLoading: false
      };

    case constants.CREATE_STOCK_TAKE_ERROR: {
      const { registerId: errRegisterId, error: stockTakeError } = action.data;
      return {
        ...state,
        updateLoading: false,
        stockTakeErrors: {
          ...state.stockTakeErrors,
          [errRegisterId]: stockTakeError
        }
      };
    }

    case constants.CLEAR_STOCK_TAKE_ERROR: {
      const registerIdToClean = action.data;
      const newErrors = { ...state.stockTakeErrors };
      delete newErrors[registerIdToClean];
      return {
        ...state,
        stockTakeErrors: newErrors
      };
    }

    case constants.UPDATE_STOCK_TAKE:
      return {
        ...state,
        updateLoading: true
      };

    case constants.UPDATE_STOCK_TAKE_SUCCESS:
      const { registerId: successUpdateRegisterId, data: updatedStockTake } = action.data;
      return {
        ...state,
        stockTakes: {
          ...state.stockTakes,
          [successUpdateRegisterId]: (state.stockTakes[successUpdateRegisterId] || []).map(stockTake =>
            stockTake.id === updatedStockTake.id ? updatedStockTake : stockTake
          )
        },
        updateLoading: false
      };

    case constants.UPDATE_STOCK_TAKE_ERROR:
      return {
        ...state,
        updateLoading: false
      };

    case constants.DELETE_STOCK_TAKE:
      return {
        ...state,
        deletingLoading: true
      };

    case constants.DELETE_STOCK_TAKE_SUCCESS:
      const deletedStockTakeId = action.data;
      const updatedStockTakes = {};

      Object.keys(state.stockTakes).forEach(registerId => {
        updatedStockTakes[registerId] = state.stockTakes[registerId].filter(
          stockTake => stockTake.id !== deletedStockTakeId
        );
      });

      return {
        ...state,
        stockTakes: updatedStockTakes,
        deletingLoading: false
      };

    case constants.DELETE_STOCK_TAKE_ERROR:
      return {
        ...state,
        deletingLoading: false
      };

    case constants.DELETE_STOCK_MANAGEMENT_REGISTER:
      return {
        ...state,
        deletingLoading: true
      };

    case constants.DELETE_STOCK_MANAGEMENT_REGISTER_SUCCESS: {
      // Remove only the deleted register's cached historical stock.
      const remainingSnapshots = { ...state.omniSnapshotsByRegisterId };
      delete remainingSnapshots[String(action.data)];
      const remainingPending = { ...state.omniSnapshotsPendingByRegisterId };
      delete remainingPending[String(action.data)];
      return {
        ...state,
        omniSnapshotsPendingByRegisterId: remainingPending,
        allstockManagementRegisters: state.allstockManagementRegisters.filter(
          register => register.id !== action.data
        ),
        omniSnapshotsByRegisterId: remainingSnapshots,
        deletingLoading: false
      };
    }

    case constants.DELETE_STOCK_MANAGEMENT_REGISTER_ERROR:
      return {
        ...state,
        deletingLoading: false
      };

    case constants.FETCH_OMNI_CURRENT_STOCK: {
      const requestIds = Array.isArray(action.data?.registerIds)
        ? action.data.registerIds : [];
      const isSnapshotRequest = requestIds.length > 0;
      const pending = { ...state.omniSnapshotsPendingByRegisterId };
      requestIds.forEach(id => { pending[String(id)] = true; });
      return {
        ...state,
        // Do not erase the historical or current warehouse caches.
        omniCurrentStock: isSnapshotRequest ? state.omniCurrentStock : [],
        omniSnapshotsPendingByRegisterId: pending,
        omniCurrentStockLoading: true,
        omniCurrentStockError: null,
        currentOmniWarehouseId: action.data?.warehouseId
      };
    }

    case constants.FETCH_OMNI_CURRENT_STOCK_SUCCESS:
      // Existing warehouse-current-stock consumers remain supported.
      return {
        ...state,
        omniCurrentStock: Array.isArray(action.data) ? action.data : [],
        omniCurrentStockLoading: false,
        omniCurrentStockError: null
      };

    case constants.FETCH_OMNI_SNAPSHOTS_SUCCESS: {
      // Bulk endpoint returns {warehouseId, registers: {'194': {stock: [...]}, ...}, legacyStock: []}.
      const payload = action.data || {};
      const registerSnapshots = payload.registers && typeof payload.registers === 'object'
        && !Array.isArray(payload.registers) ? payload.registers : {};
      const warehouseKey = String(payload.warehouseId);
      const includesLegacy = Object.values(registerSnapshots).some(
        entry => entry && entry.isSnapshot === false
      );
      const pending = { ...state.omniSnapshotsPendingByRegisterId };
      Object.keys(registerSnapshots).forEach(id => { delete pending[String(id)]; });
      return {
        ...state,
        omniSnapshotsPendingByRegisterId: pending,
        omniSnapshotsByRegisterId: {
          ...state.omniSnapshotsByRegisterId,
          ...registerSnapshots
        },
        // A snapshot-only batch must not erase legacy stock cached earlier.
        omniLegacyStockByWarehouse: includesLegacy && Array.isArray(payload.legacyStock)
          ? {
              ...state.omniLegacyStockByWarehouse,
              [warehouseKey]: payload.legacyStock
            }
          : state.omniLegacyStockByWarehouse,
        currentOmniWarehouseId: payload.warehouseId ?? state.currentOmniWarehouseId,
        omniCurrentStockLoading: false,
        omniCurrentStockError: null
      };
    }

    case constants.FETCH_OMNI_CURRENT_STOCK_ERROR: {
      const pending = { ...state.omniSnapshotsPendingByRegisterId };
      (action.request?.registerIds || []).forEach(id => { delete pending[String(id)]; });
      return {
        ...state,
        omniSnapshotsPendingByRegisterId: pending,
        omniCurrentStockLoading: false,
        omniCurrentStockError: action.error,
        currentOmniWarehouseId: null
      };
    }

    case constants.GENERATE_VARIANCE_REPORT:
      return {
        ...state,
        generatingVarianceReport: true
      };

    case constants.GENERATE_VARIANCE_REPORT_SUCCESS:
    case constants.FETCH_VARIANCE_REPORTS_SUCCESS: {
      const { registerId, data } = action.data;
      const varianceData = data?.varianceReports || data;
      return {
        ...state,
        varianceReports: {
          ...state.varianceReports,
          [registerId]: Array.isArray(varianceData) ? varianceData : []
        },
        generatingVarianceReport: false
      };
    }

    case constants.GENERATE_VARIANCE_REPORT_ERROR:
    case constants.FETCH_VARIANCE_REPORTS_ERROR: {
      const { registerId } = action.data || {};
      const newState = {
        ...state,
        generatingVarianceReport: false
      };
      
      if (registerId && !state.varianceReports[registerId]) {
        newState.varianceReports = {
          ...state.varianceReports,
          [registerId]: []
        };
      }
      return newState;
    }

    case constants.SET_STOCK_MANAGEMENT_FILTERS:
      return {
        ...state
      };

    case constants.SET_STOCK_MANAGEMENT_PAGINATION:
      return {
        ...state
      };

    case constants.CLEAR_STOCK_MANAGEMENT_REGISTER:
      return {
        ...state,
        currentStockManagementRegister: {}
      };

    case constants.CLEAR_STOCK_TAKES:
      const registerIdToClear = action.data;
      return {
        ...state,
        stockTakes: {
          ...state.stockTakes,
          [registerIdToClear]: []
        }
      };

    case constants.DELETE_LAB_STOCK_DOC_ATTACH:
      return {
        ...state,
        deleteAttachLoading: true,
        error: null
      };

    case constants.DELETE_LAB_STOCK_DOC_ATTACH_SUCCESS:
      return {
        ...state,
        deleteAttachLoading: false,
        error: null
      };

    case constants.DELETE_LAB_STOCK_DOC_ATTACH_ERROR:
      return {
        ...state,
        deleteAttachLoading: false,
        error: action.error
      };

    case constants.UPDATE_LAB_STOCK_ISADD_ISUPDATE:
      return {
        ...state,
        isAddImsDoc: action.data.isAddImsDoc || false,
        isUpdateImsDoc: action.data.isUpdateImsDoc || false
      };

    case constants.ADD_LAB_STOCK_DOC_ATTACH:
      return {
        ...state,
        isAddImsDoc: true,
        error: null
      };

    case constants.FETCH_ALL_VARIANCE_REPORTS:
      return {
        ...state,
        fetchingVarianceReportsLoading: true
      };

    case constants.FETCH_ALL_VARIANCE_REPORTS_SUCCESS: {
      const { registerId, data } = action.data;
      const varianceData = Array.isArray(data) ? data : (data?.varianceReports || data?.data || []);
      return {
        ...state,
        varianceReports: {
          ...state.varianceReports,
          [registerId]: varianceData
        },
        fetchingVarianceReportsLoading: false
      };
    }

    case constants.FETCH_ALL_VARIANCE_REPORTS_ERROR: {
      const { registerId } = action.data || {};
      return {
        ...state,
        varianceReports: registerId ? {
          ...state.varianceReports,
          [registerId]: state.varianceReports[registerId] || []
        } : state.varianceReports,
        fetchingVarianceReportsLoading: false
      };
    }

    case constants.UPDATE_VARIANCE_REPORT:
    case constants.ADD_VARIANCE_COMMENT:
      return {
        ...state,
        updateLoading: true
      };

    case constants.UPDATE_VARIANCE_REPORT_SUCCESS: {
      const { registerId: varUpdateRegId, data: updatedVarReport } = action.data;
      return {
        ...state,
        varianceReports: {
          ...state.varianceReports,
          [varUpdateRegId]: (state.varianceReports[varUpdateRegId] || []).map(report =>
            report.id === updatedVarReport.id ? updatedVarReport : report
          )
        },
        updateLoading: false
      };
    }

    case constants.ADD_VARIANCE_COMMENT_SUCCESS: {
      const commentedReport = action.data;
      const newVarReports = { ...state.varianceReports };
      Object.keys(newVarReports).forEach(regId => {
        newVarReports[regId] = newVarReports[regId].map(report =>
          report.id === commentedReport.id ? commentedReport : report
        );
      });
      return {
        ...state,
        varianceReports: newVarReports,
        updateLoading: false
      };
    }

    case constants.UPDATE_VARIANCE_REPORT_ERROR:
    case constants.ADD_VARIANCE_COMMENT_ERROR:
    case constants.DELETE_VARIANCE_ATTACHMENT_ERROR:
      return {
        ...state,
        updateLoading: false
      };

    case constants.DELETE_VARIANCE_ATTACHMENT:
      return {
        ...state,
        deleteAttachLoading: true
      };

    case constants.DELETE_VARIANCE_ATTACHMENT_SUCCESS:
      return {
        ...state,
        deleteAttachLoading: false
      };

    case constants.FETCH_VARIANCE_HISTORY:
      return {
        ...state,
        fetchingVarianceHistoryLoading: true
      };

    case constants.FETCH_VARIANCE_HISTORY_SUCCESS: {
      const { reportId, data } = action.data;
      return {
        ...state,
        varianceHistory: {
          ...state.varianceHistory,
          [reportId]: data
        },
        fetchingVarianceHistoryLoading: false
      };
    }

    case constants.FETCH_VARIANCE_HISTORY_ERROR:
      return {
        ...state,
        fetchingVarianceHistoryLoading: false
      };

    case constants.SYNC_LAB_STOCK:
      return {
        ...state,
        syncingLabStock: true,
        syncError: null
      };

    case constants.SYNC_LAB_STOCK_SUCCESS:
      return {
        ...state,
        syncingLabStock: false,
        syncError: null,
        lastSynced: action.data?.lastSynced || null
      };

    case constants.SYNC_LAB_STOCK_ERROR:
      return {
        ...state,
        syncingLabStock: false,
        syncError: action.error
      };

    case constants.FETCH_LAST_SYNC_TIME:
      return {
        ...state,
        syncingLabStock: true,
        syncError: null
      };

    case constants.FETCH_LAST_SYNC_TIME_SUCCESS:
      return {
        ...state,
        syncingLabStock: false,
        lastSynced: action.data?.lastSynced || null
      };

    case constants.FETCH_LAST_SYNC_TIME_ERROR:
      return {
        ...state,
        syncingLabStock: false,
        syncError: action.error
      };

    default:
      return state;
  }
};

export default labsStockManagementReducer;